<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ADMIN_MICOAPP_API, apiErrorText, settingPayload } from "@/config/social-api";

/**
 * Starter page component
 */
export default {
    page() {
        return {
            title: this.title,
            meta: [{ name: "description" }],
        };
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Starter page",
            items: [
                {
                    text: "Utility",
                    href: "/",
                },
                {
                    text: "Starter page",
                    active: true,
                },
            ],
            loading: false,
            appid: "",
            userinfo: [],
            free: {
                enable: 0,
                type: "wechat",
                times: null,
            },
            chargeactive: [],
        };
    },
    mounted() {
        try {
            this.userinfo = JSON.parse(localStorage.getItem("user") || "null") || {};
        } catch (e) {
            this.userinfo = {};
        }
        this.appid = this.$route.params.appid;
        this.title = "营销设置";
        this.items = [
            {
                text: this.$t("menuitems.micoapp.text"),
                href: "/",
            },
            {
                text: this.$t("menuitems.icp.micoapp.list"),
                href: "/micoapp",
            },
            {
                text: this.$t("menuitems.icp.micoapp.info"),
                href: `/micoapp/${this.appid}`,
            },
            {
                text: "营销设置",
                active: true,
            },
        ];
        this.getmicoappmenu();
    },
    methods: {
        defaultFree() {
            return {
                enable: 0,
                type: "wechat",
                times: null,
            };
        },
        parseSetting(raw, fallback) {
            if (raw == null || raw === "") {
                return typeof fallback === "function" ? fallback() : fallback;
            }
            if (typeof raw === "object") {
                return raw;
            }
            try {
                const parsed = JSON.parse(raw);
                if (parsed == null || parsed === "") {
                    return typeof fallback === "function" ? fallback() : fallback;
                }
                return parsed;
            } catch (e) {
                return typeof fallback === "function" ? fallback() : fallback;
            }
        },
        getmicoappmenu() {
            var that = this;
            that.loading = true;
            that.$axios
                .post(
                    ADMIN_MICOAPP_API,
                    {
                        action: "getmicoappsetting",
                        appid: that.$route.params.appid,
                    },
                    {
                        headers: { Openid: that.userinfo.openid },
                    }
                )
                .then(function (response) {
                    that.loading = false;
                    const data = settingPayload(response.data);
                    const free = that.parseSetting(data.free, that.defaultFree);
                    that.free = Object.assign(that.defaultFree(), free || {});
                    that.free.enable = Number(that.free.enable) || 0;
                    that.chargeactive = that.parseSetting(data.chargeactive, []);
                    if (!Array.isArray(that.chargeactive)) {
                        that.chargeactive = [];
                    }
                })
                .catch(function (error) {
                    that.loading = false;
                    that.free = that.defaultFree();
                    that.chargeactive = [];
                    that.$notify.error({
                        title: "请求错误",
                        message: (error && error.message) || String(error),
                    });
                });
        },
        save_micoappsetting(type) {
            var that = this;
            let postdata = that[type];
            that.loading = true;
            if (postdata) {
                that.$axios
                    .post(
                        ADMIN_MICOAPP_API,
                        {
                            action: "save_micoappsetting",
                            appid: that.$route.params.appid,
                            type: type,
                            datas: postdata
                        },
                        {
                            headers: { Openid: that.userinfo.openid },
                        }
                    )
                    .then(function (response) {
                        that.loading = false;
                        if (response.data.status == 200) {
                            that.$message.success({
                                message: "保存成功"
                            });
                            that.getmicoappmenu();
                        } else {
                            that.$message.error({
                                message: apiErrorText(response.data, "保存失败")
                            });
                        }
                    })
                    .catch(function (error) {
                        that.loading = false;
                        that.$notify.error({
                            title: "请求错误",
                            message: (error && error.message) || String(error),
                        });
                    });

            } else {
                that.$message.error({
                    message: "提交数据不存在"
                });
            }
        },
        addrow_charge_sale() {
            this.chargeactive.push({
                plan_id: this.chargeactive.length + 1,
                money: 0,
                gift_money: 0,
            });
        },
        delete_micoappsetting(index, rows) {
            rows.splice(index, 1);
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="micoapp-page micoapp-sale-page">
            <div class="row" v-loading="loading">
                <!-- 充值活动 -->
                <div class="col-12 col-lg-8">
                    <div class="card micoapp-sale-card">
                        <div class="card-body">
                            <div class="micoapp-toolbar">
                                <div class="micoapp-toolbar-title">
                                    <h5>充值活动</h5>
                                    <p>配置充值金额与赠送规则</p>
                                </div>
                                <div class="micoapp-toolbar-actions">
                                    <el-button @click="addrow_charge_sale" type="success" icon="el-icon-plus" size="small">
                                        添加
                                    </el-button>
                                    <el-button @click="save_micoappsetting('chargeactive')" type="primary" size="small">
                                        保存
                                    </el-button>
                                </div>
                            </div>
                            <el-table class="micoapp-table" :data="chargeactive" stripe>
                                <el-table-column prop="plan_id" label="序号" width="70" align="center" />
                                <el-table-column label="充值金额">
                                    <template slot-scope="scope">
                                        <el-input v-model.number="scope.row.money" type="number" size="small" placeholder="0" />
                                    </template>
                                </el-table-column>
                                <el-table-column label="赠送金额">
                                    <template slot-scope="scope">
                                        <el-input v-model.number="scope.row.gift_money" type="number" size="small" placeholder="0" />
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="90" align="center" fixed="right">
                                    <template slot-scope="scope">
                                        <el-button
                                            type="text"
                                            size="small"
                                            class="text-danger"
                                            @click="delete_micoappsetting(scope.$index, chargeactive)"
                                        >
                                            移除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div v-if="chargeactive.length === 0" class="micoapp-sale-empty">
                                暂无充值活动，点击上方「添加」创建
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 订单活动 / 免单规则 -->
                <div class="col-12 col-lg-4">
                    <div class="card micoapp-sale-card">
                        <div class="card-body">
                            <div class="micoapp-toolbar">
                                <div class="micoapp-toolbar-title">
                                    <h5>订单免单</h5>
                                    <p>配置免单次数与规则</p>
                                </div>
                            </div>
                            <el-form ref="form" :model="free" label-width="90px" class="micoapp-form micoapp-sale-form">
                                <el-form-item label="免单开关">
                                    <el-switch
                                        v-model="free.enable"
                                        :active-value="1"
                                        :inactive-value="0"
                                        active-text="开启"
                                        inactive-text="关闭"
                                    />
                                </el-form-item>
                                <el-form-item label="免单基准">
                                    <el-select v-model="free.type" placeholder="请选择" style="width: 100%">
                                        <el-option label="以手机号为基准" value="phone" disabled />
                                        <el-option label="以微信号为基准" value="wechat" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="免单次数">
                                    <el-input v-model.number="free.times" type="number" placeholder="请输入次数" />
                                </el-form-item>
                                <el-form-item>
                                    <el-button
                                        type="primary"
                                        :disabled="!free.type || free.times == null || free.times === ''"
                                        @click="save_micoappsetting('free')"
                                    >
                                        保存
                                    </el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
.micoapp-sale-page .micoapp-sale-card {
    margin-bottom: 1.5rem;
}

.micoapp-sale-page .micoapp-toolbar-actions {
    display: flex;
}
.micoapp-sale-page .micoapp-toolbar-actions .el-button + .el-button {
    margin-left: 0.5rem;
}

.micoapp-sale-form {
    max-width: 360px;
}

.micoapp-sale-empty {
    padding: 1.5rem;
    text-align: center;
    color: #94a3b8;
    font-size: 0.9rem;
    background: #f8fafc;
    border-radius: 12px;
    margin-top: 1rem;
}

.text-danger {
    color: #f56c6c;
}
.text-danger:hover {
    color: #f78989;
}
</style>
